import { AuditLog } from '@shared/models/audit-log.model';

import {
  StoreAvailableAdjustmentRequestEnum,
  StoreAvailableAdjustmentRequestRemarkTypeEnum
} from '../enum/store-available-adjustment-request.enum';

export const storeAvailableAdjustmentRequestStatusList = [
  { value: '', label: 'สถานะทั้งหมด' },
  { value: StoreAvailableAdjustmentRequestEnum.AWAITING_APPROVAL, label: 'รออนุมัติ' },
  { value: StoreAvailableAdjustmentRequestEnum.APPROVED, label: 'อนุมัติ' },
  { value: StoreAvailableAdjustmentRequestEnum.REJECTED, label: 'ไม่อนุมัติ' },
  { value: StoreAvailableAdjustmentRequestEnum.CANCELLED, label: 'ยกเลิก' }
];

export interface StoreAvailableAdjustmentRequestSearchCriteria {
  searchCriteria?: string;
  page: number;
  size: number;
  status?: string;
  requestedDateFrom?: string;
  requestedDateTo?: string;
}

export interface StoreAvailableAdjustmentRequestListContent {
  requestNo: string;
  refDoc: string;
  noOfItems: number;
  requestedBy: string;
  requestedDate: string;
  status: StoreAvailableAdjustmentRequestEnum;
  auditLogs: AuditLog[];
}

export interface StoreAvailableAdjustmentRequestViewResponse {
  docNo: string;
  refDoc: string;
  noOfItems: number;
  noOfCancelledItems: number;
  adjustItems: AdjustItem[];
  status: string;
  approvalFlowId: string;
  currentApprovals: string[];
  requestedDate: string;
  requestedBy: string;
  auditLogs: AuditLog[];
}

export interface AdjustItem {
  articleNo: string;
  productName: string;
  adjustAvailableStock: number;
  status: StoreAvailableAdjustmentRequestEnum;
  remarkType?: StoreAvailableAdjustmentRequestRemarkTypeEnum;
  remarkRefDoc?: string;
}
